// extracted by mini-css-extract-plugin
export default {"avatargroup":"AvatarGroup_avatargroup__RgrsO"};